/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {



  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var $wpBar = $('div#wpadminbar');
        var $win = $(window);
        var $wrap = $('body > .wrap');
        var $banner = $('header.banner');
        var $footer = $('footer.content-info');
        var $mobMenu = $('#mobile-overlay-menu');
        var $hero = $('.hero');
        var $pin = $('.hero .pin');

        var pinToggle = function(){
          // $pin.each(function(i, e){
          //   var $e = $(e);
          //   console.log($e);
          //   if($e.hasClass('active')){
          //     $e.removeClass('active');
          //   } else {
          //     $e.addClass('active');
          //     setTimeout(function(){
          //       $('body').one('click',function(){
          //         $pin.removeClass('active');
          //       }, 300);
          //     })
          //   }
          // });
          if($pin.hasClass('active')){
            $pin.removeClass('active');
          } else {
            $pin.addClass('active');
            setTimeout(function(){
              $('body').one('click',function(){
                $pin.removeClass('active');
              }, 300);
            })
          }
        }
        $pin.click(pinToggle);

        var $owlPins = $hero.find(".owl-carousel").owlCarousel({
          nav:false,
          margin: 10,
          loop: true,
          autoplay:false,
          autoheight:true,
          items: 1,
          // onResize: fitPartenairesLi
        });

        $banner.find('li.dropdown').on('show.bs.dropdown', function (e) {
            // do something…
            if($banner.hasClass('has-bg')){
              console.log('dropdown shown');
              var dropdownH = $(e.target).find('.dropdown-menu').height();
              console.log(dropdownH);
              $banner.css({paddingBottom: dropdownH + 20});
            }

        });

        $banner.find('li.dropdown').on('hide.bs.dropdown', function (e) {
            // do something…
            if($banner.hasClass('has-bg')){
              console.log('dropdown hide');
              $banner.css({paddingBottom: 0});
            }
        });


        $('header button.navbar-toggle').click(function(){
          $mobMenu.toggle();
        });

        $mobMenu.find('.close').click(function(){
          $mobMenu.toggle();
        });

        //hero
        // var $hero = $('section.hero');
        // function heroFitWindow(){
        //   console.log('win h: %s', $win.height());
        //   $hero.height($win.height() - 120);
        // }
        // heroFitWindow();
        // $win.resize(heroFitWindow);


        //wpcf7
        $('.wpcf7-form').prepend($('div.wpcf7-response-output'));

        //accordion
        $( ".cpt-list-collaborateurs .list-wrapper" ).accordion({
          active: false,
          collapsible: true,
          heightStyle: "content"
        });

        //scrollTop
        $(document).scroll(function(e){
          if($(window).scrollTop() > 50){
            $("#back-to-top").fadeIn();
          } else {
            $("#back-to-top").fadeOut();
          }
        });
        $("#back-to-top").click(function() {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        });
        $("footer .logo").click(function() {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        });

        function fitWrapToWindow(){
          var h = $win.height() - ($banner.outerHeight() + $wpBar.outerHeight() + $footer.outerHeight());
          $wrap.css('min-height', h);
        }
        fitWrapToWindow();

        // Job popup
        $('.open-popup').magnificPopup({
          type:'inline',
          midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        });


        //partenaires carousel
        $(document).ready(function(){

          // function resizeHoverText(){
          //     setTimeout(function(){
          //       // $partenaires.height($partenaires.width());
          //       var $partenaires = $('.cpt-list article.mo1_partenaires');
          //       console.log($partenaires.height());
          //       $partenaires.find('.text-content').css('padding-top', $partenaires.height()/2 - 15 );
          //     }, 300);
          // }
          // resizeHoverText();
          //
          // function fitPartenairesLi(){
          //   setTimeout(function(){
          //     $partLi = $('.cpt-list-partenaires ul.owl-carousel li');
          //     $partLi.height($partLi.width());
          //   }, 300);
          // }
          // fitPartenairesLi();
          $productsListing = $(".listing-products");
          var $owlProjects = $productsListing.find(".owl-carousel").owlCarousel({
            nav:false,
            margin: 30,
            loop: true,
            itemElement: 'article',
            autoplay:false,
            autoheight:true,
            responsive: {
              0: {
                items: 2
              },
              768: {
                items: 3
              },
              1200:{
                items: 4
              },
            },
            // onResize: fitPartenairesLi
          });
          $productsListing.find('.nav-carousel .next').click(function() {
            $owlProjects.trigger('next.owl.carousel', [300]);
          })
          // Go to the previous item
          $productsListing.find('.nav-carousel .previous').click(function() {
              $owlProjects.trigger('prev.owl.carousel', [300]);
          })

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        setTimeout(function () {
          $('.page-loader .loader-inner').fadeOut(200, function(){
            $('.page-loader').fadeOut(200);
          });
        }, 300);

        helpers.menuAffix();
        // helpers.carouselAutoHeight('.multi-content-box .carousel');

        // setTimeout(function(){
        //   if(window.location.href.match('#[a-zA-Z0-9]*')){
        //     console.log('anchor found in the current url');
        //     helpers.scrollToAnchor(window.location.href.match('#[a-zA-Z0-9]*')[0]);
        //   }
        // }, 400);


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


//helpers
var helpers = (function($){

  var $win = $(window),
      $body = $('body');
  var $wpBar = $('div#wpadminbar');
  var $win = $(window);
  var $wrap = $('body > .wrap');
  var $banner = $('header.banner');
  var $footer = $('footer.content-info');
  var $mobMenu = $('#mobile-overlay-menu');

  //export
  return {
    carouselAutoHeight: function(carouselSelector){
      console.log('helpers.carouselAutoHeight');

      var $carousel = $(carouselSelector);
      var $items = $carousel.find('.item');

      console.log($carousel);

      var maxH = 0;
      $items.each(function(i, e){
        var $eContent = $(e).find('.container');
        console.log($eContent);
        console.log($eContent.height());
        if($eContent.outerHeight() > maxH) maxH = $eContent.outerHeight();
      });
      console.log('maxH: '+ maxH);
      $carousel.find('.carousel-inner').height(maxH);
      $carousel.find('.item > .v-align').height(maxH);
    },

    menuAffix : function(){
      var top = 1;

      // //home tricks
      // if($('body').hasClass('home')){
      //   top = $('.hero').outerHeight() - 15;
      // }

      // $('.banner').affix({
      //   offset: {
      //     top: top
      //   }
      // });

      this.fadeMenu( $('.banner'), top);
    },
    fadeMenu : function($element, offset) {

      $(window).scroll( function() {
        if ($(window).scrollTop() > offset ) {

          if(!$($element).hasClass('has-bg')){
            $banner.find('li.dropdown.open').removeClass('open');
          }
          
          $($element).addClass('has-bg');




          if($body.hasClass('home')){
            $('.hero').css('margin-bottom', $('header.banner').height());
          } else{
            // if(!window.location.href.match('#')){
            // $body.css('padding-top', $('header.banner').height());
            // }
          }
        } else {
          $($element).removeClass('has-bg');

            $banner.css({paddingBottom: 0});

            if($body.hasClass('home')) {
              $('.hero').css('margin-bottom', 0);
            } else {
              $body.css('padding-top', 0);
            }
        }
      });

    },
    scrollToAnchor : function(idSelector){
      var $id = $(idSelector);
      $('html,body').animate({scrollTop: $id.offset().top},'slow');
    }
  }


})(jQuery);
